import { useState, useEffect } from 'react';
import { decodeStorage, encodeStorage } from 'functions/storageBase64'
import { getClientT1, postClientT1 } from 'services/T1Pagos'
import { useToken } from 'hooks/useToken'

export function useValUserT1(props = false){

    const {
        timeRef = 100,
        firstActive = true,
        name
    } = props

    const [readyActive, setReadyActive] = useState(firstActive)
    useEffect(()=>{
        if(firstActive){
            setReadyActive(true)
        }else{
            setReadyActive(false)
        }
        if(name){
            //console.log('nombreHookToken: ',name, ' time: ', timeRef)
        }
    },[firstActive])

    const [responseGetT1, setResponseGetT1] =useState()
    const [postT1, setPostT1] = useState()
    const clientT1 = decodeStorage('clientT1')
    const profileData = decodeStorage('profileData')
    const [errorT, setErrorT] = useState(false)


    /*  --------------------------- Inicio --------------------------------------  */
    const timeToken  = useToken({firstActive: false, name: "Valida T1", timeRef: 1000 })
    const [actionOK, setActionOk] = useState(false)
        useEffect(() => {
            setTimeout(function(){
                setActionOk('ready')
            },700)
        }, [])
   /*  --------------------------- Inicio Peticiones --------------------------------------  */
        //  Ajusta Los tiempos y refresca token
        const [serviceRT, setServiceRT] = useState(false)
        useEffect(()=>{
            if(actionOK){
                let  actTimeLS = Date.now()
                let  atExpLS = decodeStorage('access_token_exp') * 1000
    
                // console.log('------------------------------')
                // console.log('actTimeLS   : ', new Date() )
                // console.log('actTimeLS m : ', ( new Date( Date.now() + 180000) ) )
                // console.log('atExp   : ', new Date (atExpLS) )
                // console.log('time ok : ', actTimeLS <= atExpLS)
                // console.log('actionOK: ', actionOK)
                // console.log('------------------------------')
                
                if(actTimeLS <= atExpLS || Date.now() <= (decodeStorage('access_token_exp') * 1000) ){
                    setServiceRT(true)
                    //console.log('qweqweqew')
                }
                else{
                    timeToken.forceToken(true)
                }
            }
        },[timeToken.newToken, actionOK])
    /*  --------------------------- Fin --------------------------------------  */

    const [tokenT1Card, setTokenT1Card] = useState(clientT1.id)
    useEffect(()=>{
        if(serviceRT){
            if(profileData){
                if(clientT1 || !clientT1){
                    if( (!clientT1.external_id) || (profileData.idClaro != clientT1.external_id)){
                        setTimeout(function(){
                            getClientT1()
                            .then(setResponseGetT1)
                            // console.log('------2------')
                        },timeRef)
                    }
                }
            }
        }
    },[serviceRT])

    useEffect(()=>{
        if(responseGetT1){
            if(responseGetT1.statusCode === 200){
                if(responseGetT1.data){
                    if(responseGetT1.data.data){    
                        let cT1 = {
                            id: responseGetT1.data.data.id,
                            external_id: responseGetT1.data.data.id_externo
                        }
                        encodeStorage('clientT1', cT1)
                        setTokenT1Card(responseGetT1.data.data.id)
                    }
                }
            }
            if(responseGetT1.statusCode === 404){
                postClientT1()
                .then(setPostT1)
            }
            if(responseGetT1.statusCode >= 500){
               setErrorT(500)
            }
        }
    },[responseGetT1])

    useEffect(()=>{
        // console.log('postT1: ', postT1)
        if(postT1){
            if(postT1?.statusCode === 201){
                if(postT1?.data){
                    if(postT1?.data?.data){  
                        let cT1 = {
                            id: postT1?.data?.data?.id,
                            external_id: postT1?.data?.data?.id_externo
                        }
                        encodeStorage('clientT1', cT1)
                        setTokenT1Card(postT1?.data?.data?.id)
                    }
                }
            }
            else if(postT1?.statusCode === 412){
                setErrorT(412)
            }
            if(responseGetT1?.statusCode === 404){
                
            }
        }
    },[postT1])

    return{
        tokenT1Card,
        errorT
    }
}
